import React from 'react';

import { Button } from '@components/common';

import styles from './LocalCellIdsList.module.scss';

interface ILocalCellIdsListProps {
	cellIds: number[];
	onClose: () => void;
}

const LocalCellIdsList = ({
	cellIds,
	onClose,
}: ILocalCellIdsListProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.cellsWrapper}>
				{
					cellIds.map((cellId, index) => (
						<div
							key={index + cellId}
							className={styles.cellId}
						>
							{cellId}
						</div>
					))
				}
			</div>
			<Button
				large
				onClick={onClose}
				text='Close'
			/>
		</div>
	);
};

export default LocalCellIdsList;
